// extracted by mini-css-extract-plugin
export var dropdownContainer = "_kq-0";
export var leftAlign = "_kq-4";
export var listItem = "_kq-2";
export var listItemWrapper = "_kq-1";
export var operationText = "_kq-3";